var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.raw)?_c('div',_vm._l((_vm.raw.data.attributes.content),function(item,index){return (_vm.raw.data)?_c("app-content-element",{key:index,tag:"div",attrs:{"type":item.type,"objectdata":item}},[_vm._v(_vm._s(index))]):_vm._e()}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }